export const addCollaborators = (
  setCollaborators,
  collaborators,
  collaborator,
  setErrMessage,
  setPostmortemCollaborators,
  name
) => {
  const entry = { email: collaborator, status: true, ...(name ? { name } : {}) };
  setCollaborators([...collaborators, entry]);
  setErrMessage(null);
  if (typeof setPostmortemCollaborators === 'function') {
    setPostmortemCollaborators((prevCollaboratos) => [...prevCollaboratos, entry]);
  }
};
